import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { Calendar } from 'lucide-react';

export type TrendPeriod = 'week' | 'month' | 'year';

interface TrendPeriodToggleProps {
  value: TrendPeriod;
  onChange: (value: TrendPeriod) => void;
  className?: string;
}

const periodLabels: Record<TrendPeriod, string> = {
  week: 'week-over-week',
  month: 'month-over-month',
  year: 'year-over-year'
};

export default function TrendPeriodToggle({ value, onChange, className }: TrendPeriodToggleProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className={className}>
            <ToggleGroup 
              type="single" 
              value={value} 
              onValueChange={(v) => v && onChange(v as TrendPeriod)}
              className="bg-muted/50 p-0.5 rounded-lg"
            >
              <ToggleGroupItem 
                value="week" 
                aria-label="Weekly trends"
                className="text-xs px-2.5 py-1 h-7 data-[state=on]:bg-background data-[state=on]:shadow-sm"
              >
                Week
              </ToggleGroupItem>
              <ToggleGroupItem 
                value="month" 
                aria-label="Monthly trends"
                className="text-xs px-2.5 py-1 h-7 data-[state=on]:bg-background data-[state=on]:shadow-sm"
              >
                Month
              </ToggleGroupItem>
              <ToggleGroupItem 
                value="year" 
                aria-label="Yearly trends"
                className="text-xs px-2.5 py-1 h-7 data-[state=on]:bg-background data-[state=on]:shadow-sm"
              >
                Year
              </ToggleGroupItem>
            </ToggleGroup>
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>Compare trends: {periodLabels[value]}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
